<div style="position: relative; display: block; width: 200px; height: 200px;">
  <canvas 
    baseChart
    [data]="doughnutChartData"
    [type]="doughnutChartType"
    [options]="doughnutChartOptions"
    [plugins]="[DataLabelsPlugin]">
  </canvas>
  <div class="centered-title">{{ chartTitle }}</div>
</div>
